<script>
import { mapGetters } from 'vuex'
import actions from './actions'
export default {
    mixins: [actions],

    data() {
        return {
            searchValue: null,
            selectedAddress: null,
            selectedHost: null,
        }
    },

    computed: mapGetters({
        company: 'company',
        options: 'addresses',
        hosts: 'usersHosts',
    }),

    mounted() {
        this.fetch()
    },

    methods: {
        search(val) {
            this.searchValue = val
            this.fetch()
        },

        fetch() {
            this.$store.dispatch('addressFetchList', {
                search: this.searchValue,
                nopaged: true,
            })
            // @TODO: Ezt ki, mert a company userek közül kell választani
            this.$store.dispatch('usersFetchHosts')
        },

        add() {
            this.$store
                .dispatch('companiesAddAddress', {
                    address_id: this.selectedAddress.id,
                    host_user_id: this.selectedHost
                        ? this.selectedHost.id
                        : null,
                })
                .then(() => {
                    this.selectedAddress = null
                })
        },
        del(model) {
            this.$store.dispatch('companiesDelAddress', model)
        },
    },
}
</script>

<template lang="pug">
acrm-panel
    label {{ $t('COMPANIES.ADD_ADDRESS') }}
    .row.mb-4
        .col-24.col-md-20
            acrm-multi-select.mb-3.mb-lg-0(
                :options="options.data"
                :multiple="false"
                track-by="id"
                option-label="address"
                @search="search"
                v-model="selectedAddress"
                :placeholder="$t('COMPANIES.ADD_ADDRESS_HINT')"
                )

        .col.col-lg-4.col-xl.d-flex
            acrm-input-button.block-xs.ml-auto.ml-lg-0(:disabled="selectedAddress == null" icon="add" @click="add") {{ $t('BASE.ADD') }}
    acrm-setting-list-table(
        v-if='company && company.addresses && company.addresses[0]'
        :label="$t('COMPANIES.ADDED_ADDRESSES')"
        :data-array="company.addresses"
        :attributes="['address']"
        :translation="['ADDRESSES.ADDRESS']"
        del-function="companiesDelAddress")

</template>
